// Rich text editor component using Quill.js

define(['quill',
        "quill-delta",
    ], function (
        Quill,
        Delta
    ) {

    let quill;
    let quillInitiated = false;

    let toggleLinkState = (input, links) => {
        let passingCondition;
        links.forEach(link => {
            passingCondition = input.innerHTML.indexOf(`{${link.dataset.variable}}`) > -1;

            if (passingCondition) {
                link.classList.add("disabled");
            } else {
                link.classList.remove("disabled");
            }
        })
    }

    // variables insertion for Quill editor
    function addVariablePlaceholder(event){
        event.preventDefault();
        let link = event.target;
        let variable = link.dataset.variable_for;
        let input = document.querySelector(`#${variable}`)

        if (input.tagName === "DIV") {
            let position = quill.getSelection() || {
                index: 0,
                length: 0
            };
            quill.insertText(position.index + position.length, `{${link.dataset.variable}}`);
        } else {
            insertAtCursor(input, `{${link.dataset.variable}}`);
            link.classList.add("disabled");
            input.click();
        }
    }

    // handle variable functionality (for Quill editor)
    let addVariableFunctionality = (variableWrapSelector) => {
        let input = document.querySelector('#quillEditor .ql-editor');
        let variableWrap = document.querySelector(`.variable-wrap${variableWrapSelector}`);
        if (!input) return;

        let addVariableLinks = variableWrap.querySelectorAll("a.add-variable");

        toggleLinkState(input, addVariableLinks);

        addVariableLinks.forEach(link => {
            link.addEventListener("click", addVariablePlaceholder);
        })

        quill.on('text-change', () => {
            toggleLinkState(input, addVariableLinks);
        })
    }

    let initQuillEventListeners = (options) => {
        let quillTextArea = document.querySelector('#quillEditor');

        if(!quillTextArea || quillInitiated) return;

        quillInitiated = true;

        function htmlToText(html) {
            var temp = document.createElement('div');
            temp.innerHTML = html;
            return temp.textContent; // Or return temp.innerText if you need to return only visible text. It's slower.
        }

        //special character count for Quill editor, since it is unique                
        let currentLength = htmlToText(quillTextArea.innerHTML).length;
        let limit = options.charLimit || 500;

        quillTextArea.insertAdjacentHTML('afterend', `<div data-limit="${limit}" class="char-count"><span class="current">${currentLength}</span> / ${limit}</div>`);
        let limitMet = false;

        let execution = (event) => {
            currentLength = htmlToText(quillTextArea.innerHTML).length;
            let countEl = quillTextArea.parentNode.querySelector(".char-count");
            let countSpan = countEl.querySelector(".current");

            countSpan.innerText = currentLength;

            if (currentLength > limit) {
                countEl.classList.add("error");
                quillTextArea.classList.add("danger");
                limitMet = true;
                return;
            }

            if (limitMet && currentLength <= limit) {
                countEl.classList.remove("error");
                quillTextArea.classList.remove("danger");
                limitMet = false;
            }
        }

        quillTextArea.addEventListener("keyup", execution);
        quillTextArea.addEventListener("click", execution);

        quillTextArea.addEventListener("paste", (event) => {
            // prevent pasting of anything but text, and update cursor position after pasting
            let text = (event.clipboardData || window.clipboardData).getData("text");
            event.preventDefault();
            if(text) {
                let originalIndex = quill.getSelection().index;
                quill.updateContents(new Delta()
                    .retain(quill.getSelection().index)
                    .insert(text)
                );
                setTimeout(() => {
                    quill.setSelection(originalIndex + text.length, 0)
                }, 10)
            }
        });

        addVariableFunctionality(options.variableWrapSelector);
    }

    let initQuillEditor = (options) => {
        textArea = document.querySelector(options.textareaId);
        quill = new Quill('#quillEditor', {
            modules: {
                toolbar: '#quillToolbar'
            },
            formats: ['bold', 'italic', 'underline', 'link'],
            placeholder: options.placeholder || '',
        });

        let quillEditorBody = document.querySelector("#quillEditor .ql-editor");

        quillEditorBody.setAttribute("data-default", textArea.dataset.default)

        //remove redunant <p> tags
        let textAreaValue = textArea.value.trim();
        quillEditorBody.innerHTML = textAreaValue;

        quill.on('text-change', () => {
            textArea.value = quill.root.innerHTML;
        });

        initQuillEventListeners(options);
    }

    return function (options) {
        /* options = {
            textareaId: "#id_of_textarea",
            charLimit: 500,
            variableWrapSelector: ".class-of-variable-wrap", // optional,
            placeholder: "Enter text here..." // optional,
        } */

        initQuillEditor(options);

        return {
            component: function() {
                if (quill) {
                    return quill;
                }
                return null;
            }
        };
    }
});